(() => {
  if (customElements.get('gn-package-preview')) return;
  const certificates = {
    original: { width:2048,height:1582,nameX:1024,nameY:785,nameWidth:1140,nameSize:88,dateX:1276,dateY:1091,dateWidth:410,dateSize:48,color:'#102a39',font:'Original',sku:'ORD-CERT-01' },
    fancy: { width:1582,height:2048,nameX:795,nameY:878,nameWidth:990,nameSize:94,dateX:909,dateY:1300,dateWidth:340,dateSize:43,color:'#26351e',font:'Fancy',sku:'ORD-CERT-03' },
    whimsical: { width:2048,height:1582,nameX:1028,nameY:778,nameWidth:970,nameSize:94,dateX:1258,dateY:1069,dateWidth:405,dateSize:49,color:'#232321',font:'Whimsical',sku:'ORD-CERT-02' }
  };
  const cards = {
    oath: { sku:'ORD-CARD-01',font:'Oath',name:{x:292,y:501,width:380,size:44},date:{x:650,y:501,width:257,size:27},color:'#422b1d' },
    rites: { sku:'ORD-CARD-02',font:'Rites',name:{x:326,y:542,width:326,size:42},date:{x:650,y:542,width:238,size:26},color:'#294438' },
    threshold: { sku:'ORD-CARD-03',font:'Threshold',name:{x:360,y:548,width:530,size:36},date:{x:803,y:548,width:245,size:26},color:'#f6e8d1' },
    proverb: { sku:'ORD-CARD-04',font:'Proverb',name:{x:293,y:565,width:440,size:40},date:{x:679,y:565,width:238,size:26},color:'#f6e8d1' }
  };
  const image = url => new Promise((resolve,reject) => {
    if (!url) return reject(new Error('Document artwork is missing.'));
    const img=new Image();
    img.crossOrigin='anonymous';
    img.onload=()=>resolve(img);
    img.onerror=()=>reject(new Error('Document artwork could not be loaded. Please try again.'));
    img.src=url;
  });
  const formattedDate = value => {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value) || value < '2024-01-15') return '';
    const [year,month,day]=value.split('-').map(Number);
    const date=new Date(year,month-1,day);
    if (date.getFullYear()!==year || date.getMonth()!==month-1 || date.getDate()!==day) return '';
    return new Intl.DateTimeFormat('en-US',{month:'long',day:'numeric',year:'numeric'}).format(date);
  };
  const canvas = (width,height) => {
    const c=document.createElement('canvas');
    c.width=width;c.height=height;
    return c;
  };
  const fit = (ctx,value,width,max,min,font) => {
    for(let size=max;size>=min;size--){
      ctx.font=`${size}px "Gnome Package ${font}", Georgia, serif`;
      if(ctx.measureText(value).width<=width) return true;
    }
    return false;
  };
  const drawCertificateText = (ctx,d,name,date) => {
    ctx.textAlign='center';ctx.textBaseline='alphabetic';ctx.fillStyle=d.color;
    if(name){
      if(!fit(ctx,name,d.nameWidth,d.nameSize,24,d.font)) throw new Error('This name does not fit on the certificate. Please shorten it.');
      ctx.fillText(name,d.nameX,d.nameY);
    }
    if(date){
      if(!fit(ctx,date,d.dateWidth,d.dateSize,25,d.font)) throw new Error('The date does not fit on the certificate.');
      ctx.fillText(date,d.dateX,d.dateY);
    }
  };
  const drawCardText = (ctx,d,name,date) => {
    ctx.fillStyle=d.color;ctx.textAlign='center';ctx.textBaseline='alphabetic';
    if(name){
      if(!fit(ctx,name,d.name.width,d.name.size,16,d.font)) ctx.font=`16px "Gnome Package ${d.font}", Georgia, serif`;
      ctx.fillText(name,d.name.x,d.name.y,d.name.width);
    }
    if(date){
      if(!fit(ctx,date,d.date.width,d.date.size,17,d.font)) throw new Error('The date does not fit on the card.');
      ctx.fillText(date,d.date.x,d.date.y);
    }
  };
  const drawLetterText=(ctx,name,date)=>{
    ctx.textAlign='center';ctx.textBaseline='alphabetic';ctx.fillStyle='#2c2924';
    if(name){
      let size=45;
      while(size>=18){
        ctx.font=`${size}px Georgia, 'Times New Roman', serif`;
        if(ctx.measureText(name).width<=520) break;
        size--;
      }
      if(size<18) ctx.font="18px Georgia, 'Times New Roman', serif";
      ctx.fillText(name,1113,1738,520);
    }
    if(date){ctx.font="42px Georgia, 'Times New Roman', serif";ctx.fillText(date,1113,1877,520)}
  };
  const watermark=ctx=>{
    const {width,height}=ctx.canvas;
    ctx.save();ctx.translate(width/2,height/2);ctx.rotate(-Math.PI/6);
    ctx.fillStyle='rgba(63,45,34,.27)';
    ctx.font=`700 ${Math.round(Math.min(width*.12,height*.16))}px Arial, sans-serif`;
    ctx.textAlign='center';ctx.textBaseline='middle';
    for(const offset of [-height*.28,0,height*.28]) ctx.fillText('PREVIEW',0,offset,width*.72);
    ctx.restore();
  };
  const copyTo=(target,source,mark=true)=>{
    target.width=source.width;target.height=source.height;
    const ctx=target.getContext('2d');
    ctx.drawImage(source,0,0);
    if(mark)watermark(ctx);
  };
  class PackagePreview extends HTMLElement {
    connectedCallback(){
      this.form=this.closest('form');
      this.nameInput=this.form?.querySelector('input[name="properties[Name to print]"]');
      this.dateInput=this.form?.querySelector('input[name="properties[Date of ordainment]"]');
      this.variantInput=this.form?.querySelector('input[name="id"]');
      this.error=this.querySelector('[role="alert"]');
      if(!this.form || !this.nameInput || !this.dateInput || !this.variantInput || !this.error) return;
      this.images=new Map();this.fonts=new Map();
      this.panels=[...this.querySelectorAll('[data-preview-panel]')];
      this.tabs=[...this.querySelectorAll('[role="tab"]')];
      this.tabs.forEach((tab,index)=>{
        tab.addEventListener('click',()=>this.selectTab(index));
        tab.addEventListener('keydown',event=>{
          if(!['ArrowRight','ArrowLeft','Home','End'].includes(event.key))return;
          event.preventDefault();
          const next=event.key==='Home'?0:event.key==='End'?this.tabs.length-1:
            (index+(event.key==='ArrowRight'?1:-1)+this.tabs.length)%this.tabs.length;
          this.selectTab(next);this.tabs[next].focus();
        });
      });
      const dialog=this.querySelector('dialog');
      this.querySelector('.gn-package-preview__zoom')?.addEventListener('click',()=>{
        const source=this.querySelector('[data-preview-letter]');
        copyTo(this.querySelector('[data-preview-letter-zoom]'),source,false);
        dialog.showModal();
      });
      this.querySelector('.gn-package-preview__close')?.addEventListener('click',()=>dialog.close());
      dialog?.addEventListener('click',e=>{if(e.target===dialog)dialog.close()});
      this.nameInput.addEventListener('input',()=>this.draw());
      this.dateInput.addEventListener('input',()=>this.draw());
      this.lastVariant=this.variantInput.value;
      this.poll=setInterval(()=>{
        if(this.variantInput.value===this.lastVariant)return;
        this.lastVariant=this.variantInput.value;
        this.draw();
      },200);
      this.draw();
    }
    disconnectedCallback(){clearInterval(this.poll)}
    selectTab(index){
      this.tabs.forEach((tab,i)=>{
        tab.setAttribute('aria-selected',i===index?'true':'false');
        tab.tabIndex=i===index?0:-1;
        this.panels[i].hidden=i!==index;
      });
    }
    showError(message){this.error.textContent=message;this.error.hidden=!message}
    selected(){
      const variant=this.querySelector('.gn-package-preview__variants [data-id="'+this.variantInput.value+'"]');
      const cert=variant?.dataset.certificate?.toLowerCase();
      const card=variant?.dataset.card?.replace(/^The /i,'').toLowerCase();
      if(!certificates[cert] || !cards[card]) throw new Error('Please select a certificate and card design.');
      return {cert,card,id:this.variantInput.value};
    }
    getImage(key,url){
      if(!this.images.has(key))this.images.set(key,image(url));
      return this.images.get(key);
    }
    getFont(key){
      if(!this.fonts.has(key)){
        const url=this.dataset['font'+key[0].toUpperCase()+key.slice(1)];
        this.fonts.set(key,(async()=>{
          if(!url)throw new Error('The document font is missing.');
          const face=new FontFace('Gnome Package '+key,`url("${url}") format("woff")`);
          await face.load();document.fonts.add(face);
        })());
      }
      return this.fonts.get(key);
    }
    async makeCertificate(key,name,date){
      const d=certificates[key];
      const url=this.dataset['certificate'+key[0].toUpperCase()+key.slice(1)];
      const [art]=await Promise.all([this.getImage('cert-preview-'+key,url),this.getFont(d.font.toLowerCase())]);
      const c=canvas(d.width,d.height),ctx=c.getContext('2d');
      ctx.drawImage(art,0,0,d.width,d.height);
      drawCertificateText(ctx,d,name,date);
      return c;
    }
    async makeCard(key,name,date){
      const d=cards[key];
      const [front,back]=await Promise.all([
        this.getImage('card-front-'+key,this.dataset['cardFront'+key[0].toUpperCase()+key.slice(1)]),
        this.getImage('card-back-'+key,this.dataset['cardBack'+key[0].toUpperCase()+key.slice(1)]),
        this.getFont(d.font.toLowerCase())
      ]);
      const f=canvas(1020,630),b=canvas(1020,630);
      f.getContext('2d').drawImage(front,0,0,1020,630);
      const ctx=b.getContext('2d');ctx.drawImage(back,0,0,1020,630);
      drawCardText(ctx,d,name,date);
      return {front:f,back:b};
    }
    async makeLetter(name,date){
      const art=await this.getImage('letter-preview',this.dataset.letterPreview);
      const c=canvas(1582,2048),ctx=c.getContext('2d');
      ctx.drawImage(art,0,0,1582,2048);
      ctx.globalCompositeOperation='multiply';
      ctx.fillStyle='#faf3e7';ctx.fillRect(0,0,1582,2048);
      ctx.globalCompositeOperation='source-over';
      drawLetterText(ctx,name,date);
      return c;
    }
    async draw(){
      const sequence=this.sequence=(this.sequence||0)+1;
      try{
        const selected=this.selected();
        const name=this.nameInput.value.trim().replace(/\s+/g,' ');
        const date=formattedDate(this.dateInput.value);
        const [cert,card,letter]=await Promise.all([
          this.makeCertificate(selected.cert,name,date),
          this.makeCard(selected.card,name,date),
          this.makeLetter(name,date)
        ]);
        if(sequence!==this.sequence || selected.id!==this.variantInput.value)return;
        copyTo(this.querySelector('[data-preview-certificate]'),cert);
        copyTo(this.querySelector('[data-preview-card-back]'),card.back);
        copyTo(this.querySelector('[data-preview-card-front]'),card.front);
        copyTo(this.querySelector('[data-preview-letter]'),letter);
        this.showError('');
      }catch(e){if(sequence===this.sequence)this.showError(e.message||'The preview could not be prepared.')}
    }
  }
  customElements.define('gn-package-preview',PackagePreview);
})();
